import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import parse from 'html-react-parser';

import PageBanner from '../../../common/PageBanner/PageBanner';
import Spinner from '../../../components/Spinner/Spinner';

import useGetPage from '../../../hooks/useGetPage/useGetPage';
import { useGeneralDataContext } from '../../../contexts/useGeneralDataContext/useGeneralDataContext';
import useSetPageTitle from '../../../hooks/useSetPageTitle/useSetPageTitle';

import {
  AVAILABLE_LANGUAGES,
  DEFAULT_IMAGE_ALT_TEXT,
} from '../../../config/constants/contants';

import bannerImage from '../../../images/vitralii.webp';

import styles from './PrivacyPolicy.module.scss';
import commons from '../../../shared/styles/common.module.scss';

const PrivacyPolicy = () => {
  const { t } = useTranslation();
  const { language } = useGeneralDataContext();

  const pageId = language === AVAILABLE_LANGUAGES.RO ? 8922 : 9733;

  const { data, isLoading } = useGetPage(pageId);

  useSetPageTitle({
    pageTitle: `${t('pages.privacy-policy')} - ${t('general.website-name')}`,
  });

  return (
    <div>
      <PageBanner
        imageSrc={bannerImage}
        imageText={DEFAULT_IMAGE_ALT_TEXT}
        title={t('pages.privacy-policy')}
      />
      <div className={classNames(styles.content, commons.container)}>
        {isLoading ? (
          <Spinner variant='green' />
        ) : (
          data && (
            <div className={styles.contentValue}>{parse(data.content)}</div>
          )
        )}
      </div>
    </div>
  );
};

export default PrivacyPolicy;
